var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function useReadFile(path) {
    return __awaiter(this, void 0, void 0, function* () {
        const state = {
            data: {
                fileContent: '',
                fileName: path.split('/').pop() || '',
            },
            error: null,
            loading: true,
        };
        function loadContent() {
            return __awaiter(this, void 0, void 0, function* () {
                fetch(path)
                    .then((response) => __awaiter(this, void 0, void 0, function* () {
                    if (response.ok) {
                        state.data.fileContent = yield response.text();
                    }
                    else {
                        state.error = new Error(response.statusText);
                    }
                }))
                    .catch(error => {
                    state.error = error;
                })
                    .finally(() => {
                    state.loading = false;
                });
            });
        }
        yield loadContent();
        return state;
    });
}
